"use client";
import * as e from "react";
const o = () => {
}, t = typeof document < "u" ? e.useLayoutEffect : o;
export {
  t as u
};
